import { ArrowRightLeft } from 'lucide-react'
import { useAuthStore } from '../core/stores/authStore'

interface OwnershipBadgeProps {
  ownerId: string | null | undefined
  ownerName: string | null | undefined
  onTransfer?: () => void
}

/**
 * Badge che mostra il proprietario di un documento.
 * Se l'utente corrente è il proprietario o admin, mostra il pulsante "Cedi controllo".
 */
export function OwnershipBadge({ ownerId, ownerName, onTransfer }: OwnershipBadgeProps) {
  const user = useAuthStore((s) => s.user)
  if (!ownerId || !ownerName) return null

  const isOwner = user?.user_id === ownerId
  const isAdmin = user?.role === 'admin'
  const canTransfer = (isOwner || isAdmin) && onTransfer

  return (
    <div className="inline-flex items-center gap-1.5">
      <span className={`inline-flex items-center px-2.5 py-1 rounded-full border text-xs font-medium ${
        isOwner
          ? 'bg-indigo-50 text-indigo-700 border-indigo-200'
          : 'bg-gray-50 text-gray-600 border-gray-200'
      }`}>
        {ownerName}{isOwner && ' (tu)'}
      </span>
      {canTransfer && (
        <button
          onClick={onTransfer}
          className="inline-flex items-center gap-1 px-2 py-1 text-xs text-gray-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-full border border-gray-200 transition-colors"
          title={`Cedi controllo (attuale: ${ownerName})`}
        >
          <ArrowRightLeft className="w-3 h-3" />
          Cedi
        </button>
      )}
    </div>
  )
}
